/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalOptOut } from './GlobalOptOut';
import {
    GlobalOptOutFromJSON,
    GlobalOptOutFromJSONTyped,
    GlobalOptOutToJSON,
    GlobalOptOutToJSONTyped,
} from './GlobalOptOut';

/**
 * 
 * @export
 * @interface ListGlobalOptOutsOutputBody
 */
export interface ListGlobalOptOutsOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ListGlobalOptOutsOutputBody
     */
    readonly $schema?: string;
    /**
     * Global Opt Outs
     * @type {Array<GlobalOptOut>}
     * @memberof ListGlobalOptOutsOutputBody
     */
    globalOptOuts: Array<GlobalOptOut> | null;
}

/**
 * Check if a given object implements the ListGlobalOptOutsOutputBody interface.
 */
export function instanceOfListGlobalOptOutsOutputBody(value: object): value is ListGlobalOptOutsOutputBody {
    if (!('globalOptOuts' in value) || value['globalOptOuts'] === undefined) return false;
    return true;
}

export function ListGlobalOptOutsOutputBodyFromJSON(json: any): ListGlobalOptOutsOutputBody {
    return ListGlobalOptOutsOutputBodyFromJSONTyped(json, false);
}

export function ListGlobalOptOutsOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGlobalOptOutsOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'globalOptOuts': (json['global_opt_outs'] == null ? null : (json['global_opt_outs'] as Array<any>).map(GlobalOptOutFromJSON)),
    };
}

export function ListGlobalOptOutsOutputBodyToJSON(json: any): ListGlobalOptOutsOutputBody {
    return ListGlobalOptOutsOutputBodyToJSONTyped(json, false);
}

export function ListGlobalOptOutsOutputBodyToJSONTyped(value?: Omit<ListGlobalOptOutsOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'global_opt_outs': (value['globalOptOuts'] == null ? null : (value['globalOptOuts'] as Array<any>).map(GlobalOptOutToJSON)),
    };
}

